<div class="">
    <input
      type="text"
      [disabled]="!data.length"
      (input)="getValue($event)"
      class="form-control"
      name=""
      id=""
      placeholder="Search..."
      autocomplete="on"
    />
</div>
